import axios from 'axios';
// config
import { HOST_API } from '../config';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({
  baseURL: HOST_API,
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

axiosInstance.interceptors.request.use(config => {

  const token = localStorage.getItem("accessToken")

  if (token) {

    axios.defaults.headers.Authorization = `Bearer ${token}`

  }

  return config

});


export default axiosInstance;
